// Pure, unit-testable normalizer for the pre-generated city copy: a structured
// object with an intro plus heading/body section pairs. Anything else (older
// text-blob records, partial objects) normalizes to null -> translated fallback.

// Render order; a pair renders only when both fields carry text.
const SECTION_KEYS = [
  ['howItWorks', 'howItWorksHeading', 'howItWorksBody'],
  ['localContext', 'localContextHeading', 'localContextBody'],
  ['intake', 'intakeHeading', 'intakeBody'],
];

const text = (value) => (typeof value === 'string' && value.trim() ? value.trim() : null);

/**
 * Returns `{ intro, sections: [{ key, heading, body }] }`, or `null` when nothing
 * is renderable. The supplied title, metaDescription, h1 and faq are deliberately
 * not surfaced - the page keeps its localized heading, metadata and FAQ.
 */
export const normalizeAiContent = (content) => {
  if (!content || typeof content !== 'object' || Array.isArray(content)) {
    return null;
  }

  const intro = text(content.intro);

  const sections = SECTION_KEYS.map(([key, headingKey, bodyKey]) => {
    const heading = text(content[headingKey]);
    const body = text(content[bodyKey]);
    return heading && body ? { key, heading, body } : null;
  }).filter(Boolean);

  if (!intro && sections.length === 0) {
    return null;
  }

  return { intro, sections };
};

export default normalizeAiContent;
